module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/calendar-16d349bacf49c48aae3c56c9907dfbea.svg";